import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";
import { createUseStyles } from "react-jss";


const styles = createUseStyles({
  carouselModal: {
    width: "100%",
    maxWidth: "948px",
    height: "755px",
    minWidth: "auto",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      width: "100%",
      height: "100%",
      minWidth: "auto",
    },
    "& .modal-header": {
      padding: "24px 24px 20px 24px",
      [`@media (max-width: ${breakpoints.md}px)`]: {
        padding: "10px 20px 10px 10px",
      },
      "& div": {
        border: "none",
        boxShadow: "none",
        width: "fit-content",
        height: "46px",
        [`@media (max-width: ${breakpoints.md}px)`]: {
          height: "26px",
          padding: "0px",
        },
        padding: "10px",
        "& svg": {
          display: "flex"
        }
      },
    },
    "& .modal-content": {
      borderRadius: 0,
      boxShadow: "none",
      border: "none",
    },
    "& .modal-title": {
      padding: "0 24px",
      fontSize: "18px",
      fontWeight: "600",
      lineHeight: "28px",
    },
    "& .body, .modal-body": {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
    },
    "& .modal-body": {
      padding: 0,
    },
  },
  contentStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "55px 193px",
    minHeight: "665px",
    height: "665px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      padding: "10px 10px",
      height: "425px",
      minHeight: "425px",
    },
  },
  united: {
    backgroundColor: colors.carouselBlue,
  },
  delta: {
    backgroundColor: colors.veryLightGrey,
  },
  american: {
    backgroundColor: colors.blueLight700,
  },
  alaska: {
    backgroundColor: colors.blueLight700,
  },
  carouselImage: {
    maxHeight:"650px",
    maxWidth:"948px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      maxHeight: "400px",
      maxWidth: "350px",
    },
  },
  arrowLeftButton: {
    border: "none",
    marginRight: "16px",
    "&:hover": {
      border: "none",
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      padding: "5px"
    },
  },
  arrowRightButton: {
    border: "none",
    "&:hover": {
      border: "none",
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      padding: "5px"
    },
  },

})

export default styles;